import { TRANSLATED_ACTIONS } from '@/common/messages/actions';
import { defineMessages } from '@/components/formatted_message/FormattedMessage';

export const Page = defineMessages({
  helmet: {
    id: 'app.auth.verify.Page.helmet',
  },
  title: {
    id: 'app.auth.verify.Page.title',
  },
  description: {
    id: 'app.auth.verify.Page.description',
  },
  login: {
    id: 'app.auth.login.Form.login',
  },
  trustDevice: {
    id: 'app.auth.verify.Page.trustDevice',
  },
  lostDevice: {
    id: 'app.auth.verify.Page.lostDevice',
  },
  recoverAccess: {
    id: 'app.auth.verify.Page.recoverAccess',
  },
  back: TRANSLATED_ACTIONS.back,
  alertMessage: {
    id: 'app.auth.verify.Page.alertMessage',
  },
  passwordAgainTitle: {
    id: 'app.auth.verify.Page.passwordAgainTitle',
  },
});

export const BackupCodes = defineMessages({
  title: {
    id: 'app.auth.twoFactor.BackupCodes.title',
  },
  description: {
    id: 'app.auth.twoFactor.BackupCodes.description',
  },
  codesCopiedToClipboard: {
    id: 'app.auth.twoFactor.BackupCodes.codesCopiedToClipboard',
  },
  continue: TRANSLATED_ACTIONS.continue,
  close: TRANSLATED_ACTIONS.close,
});

export const SetupContent = defineMessages({
  description: {
    id: 'app.auth.twoFactor.SetupContent.description',
  },
  scanCompleted: {
    id: 'app.auth.twoFactor.SetupContent.scanCompleted',
  },
  cancel: TRANSLATED_ACTIONS.cancel,
  keyCopiedToClipboard: {
    id: 'app.auth.twoFactor.SetupContent.keyCopiedToClipboard',
  },
  addKeyManually: {
    id: 'app.auth.twoFactor.SetupContent.addKeyManually',
  },
});
